import React from 'react';

const FormField = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  error,
  required = false,
  placeholder = '',
  options = null,
  disabled = false,
  className = '',
  inline = false,  // New prop for inline layout
  labelClass = '', // New prop for custom label classes
  includeEmptyOption = true,
  ...props
}) => {
  const inputId = `form-${name}-${Math.random().toString(36).substr(2, 9)}`;
  
  const renderInput = () => {
    if (type === 'select') {
      return (
        <select
          id={inputId}
          name={name}
          value={value || ''}
          onChange={onChange}
          className={`form-select ${error ? 'is-invalid' : ''} ${className}`}
          disabled={disabled}
          {...props}
        >
          {includeEmptyOption && (
            <option value="" disabled>
              Select {label}
            </option>
          )}
          {options && options.map((option) => (
            <option key={option.value || option} value={option.value || option}>
              {option.label || option}
            </option>
          ))}
        </select>
      );
    }

    if (type === 'textarea') {
      return (
        <textarea
          id={inputId}
          name={name}
          value={value || ''}
          onChange={onChange}
          className={`form-control ${error ? 'is-invalid' : ''} ${className}`}
          placeholder={placeholder}
          disabled={disabled}
          {...props}
        />
      );
    }

    if (type === 'radio' || type === 'checkbox') {
      const input = (
        <input
          type={type}
          id={inputId}
          name={name}
          checked={type === 'radio' ? value === props.value : !!value}
          onChange={onChange}
          className={`form-check-input ${error ? 'is-invalid' : ''} ${className}`}
          disabled={disabled}
          {...props}
        />
      );

      if (inline) {
        return (
          <div className={`form-check form-check-inline ${labelClass}`}>
            {input}
            {label && (
              <label className="form-check-label ms-1" htmlFor={inputId}>
                {label}
                {required && <span className="text-danger">*</span>}
              </label>
            )}
          </div>
        );
      }

      return (
        <div className={`form-check ${labelClass}`}>
          {input}
          {label && (
            <label className="form-check-label" htmlFor={inputId}>
              {label}
              {required && <span className="text-danger">*</span>}
            </label>
          )}
        </div>
      );
    }

    return (
      <input
        type={type}
        id={inputId}
        name={name}
        value={value || ''}
        onChange={onChange}
        className={`form-control ${error ? 'is-invalid' : ''} ${className}`}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      />
    );
  };

  // For radio/checkbox, we handle the label differently
  if (type === 'radio' || type === 'checkbox') {
    return (
      <div className="mb-3">
        {renderInput()}
        {error && <div className="invalid-feedback d-block">{error}</div>}
      </div>
    );
  }

  // For other input types
  return (
    <div className="mb-3">
      {label && (
        <label htmlFor={inputId} className={`form-label ${labelClass}`}>
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}
      {renderInput()}
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default FormField;